import React, { useCallback, useEffect, useState } from 'react';
import CallAPI from '../../../../../adminpanel/components/commonComponents/AxiosHelper';
import DataTableComponent from '../../../commonComponents/DataTableComponent';
import SFTPTypeConnect from '../SFTPTypeConnect';
import TablePreview from '../TablePreview';

const fileViews = ["sftp", "files"];

function StepThree({ authData, initialData, setConnectionType }) {

    const [tableMetaData, settableMetaData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [progressTable, setprogressTable] = useState(true);

    useEffect(() => {
        if (fileViews.indexOf(initialData.connection_type.toLowerCase()) == -1) {
            let params = {
                siteId: authData.siteId,
                selection: 'table',
                connectionId: initialData.connectionId,
            }

            CallAPI('get', '/app/get_connection_selected_data', null, params, 0, function (response) {
                if (response.status === true) {
                    let data = response.information;
                    settableMetaData(data);
                    setprogressTable(false);
                }
            }, authData)
        }
    }, [])

    const handleSelection = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    let filterStatus = true;
    let columnData = [
        { "virtualName": "Tables", "rawField": "clientTableName" },
    ]

    return (
        <>
            {
                fileViews.indexOf(initialData.connection_type.toLowerCase()) == -1 ?
                    <div className="row">
                        <div className="col-md-3">
                            <DataTableComponent
                                tableData={tableMetaData}
                                setTableData={settableMetaData}
                                addFilter={filterStatus}
                                columnData={columnData}
                                selectableRows={true}
                                // paginationPerPage={100}
                                // paginationRowsPerPageOptions={[100, 150, 200, 250]}
                                onSelectedRowsChangeEvent={handleSelection}
                                progressPending={progressTable}
                                filterColumnName={'clientTableName'}
                                paginationStatus={false}
                                tableHeight={"50vh"}
                            />
                        </div>
                        <div className="card col-md-9">
                            <TablePreview authData={authData} selectedRows={selectedRows} selectedCount={selectedRows.length} initialData={initialData} setConnectionType={setConnectionType} setSelectedRows={setSelectedRows} />
                        </div>
                    </div> :
                    <div className="card"><SFTPTypeConnect authData={authData} initialData={initialData} setConnectionType={setConnectionType} /></div>
            }
        </>
    );
}

export default StepThree;